import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import SkeletonGrid from '../SkeletonLoader/SkeletonGrid';
import './style.css';

const DetailedStatusGrid = ({ isLoading, data = [], showLink = false }) => {
  return (
    <Row className="mt-4">
      {isLoading ? 
        <SkeletonGrid
          rowCount={1}
          colCount={data?.length || 4}
          className='progress-bar-card h-120 p-3 mb-2 mt-2'
        />
        :
        <>
          {data?.map((item, index) => {
            return (
              <Col className={`no-select ${showLink && item.onClick ? 'cursor-pointer' : ''}`} onClick={showLink && item.onClick ? () => item.onClick() : undefined} key={index}>
                {item.icon ? (
                  <div className="d-flex h-120 flex-column total-score-card text-center justify-content-center">
                    <div className="d-flex justify-content-between align-items-center px-3">
                      {item.icon}
                      <div className='mx-3'>
                        <h1 className='fs-2 fw-semibold m-0 text-color-red'>
                          {item.value}
                        </h1>
                        <h1 className="fw-semibold mb-0">{item.label}</h1>
                        {showLink && <p className='text-castleOrange'>Click for details</p>}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex h-120 flex-column progress-bar-card text-center justify-content-center">
                    <div className="d-flex justify-content-between align-items-center px-3">
                      <h3 className="text-color-red mb-0 mr-2">
                        {item.value}
                      </h3>
                      <h1 className="mb-0">{item.label}</h1>
                    </div>
                  </div>
                )}
              </Col>
            );
          })}
        </> 
      }
    </Row>
  );
};

DetailedStatusGrid.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isMain: PropTypes.bool,
      onClick: PropTypes.func
    })
  ).isRequired,
  showLink: PropTypes.bool
};

export default DetailedStatusGrid;